export default "<i class=\"fas fa-pen\" (click)=\"propagateClick  == 'true' && !disabled && editItem()\" [ngClass]=\"{'disabled': disabled}\"></i>\r\n"